<template>
  <div class="border-b border-pruta-green/50 flex flex-col items-start justify-center py-8 w-full">
    <button
      @click="toggleOpen"
      class="flex gap-2 items-center justify-center pr-2 w-full text-left"
      :aria-expanded="isOpen"
    >
      <p class="flex-1 font-medium text-lg text-gray-darkest font-inter">
        {{ question }}
      </p>
      <div
        class="flex items-center justify-center transition-transform duration-300"
        :class="{ 'rotate-180': isOpen, 'rotate-0': !isOpen }"
      >
        <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </div>
    </button>

    <Transition
      enter-active-class="transition-all duration-300 ease-in-out"
      enter-from-class="opacity-0 max-h-0"
      enter-to-class="opacity-100 max-h-96"
      leave-active-class="transition-all duration-300 ease-in-out"
      leave-from-class="opacity-100 max-h-96"
      leave-to-class="opacity-0 max-h-0"
    >
      <div v-if="isOpen" class="overflow-hidden">
        <p class="text-gray-darker pt-4 font-inter">
          {{ answer }}
        </p>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  question: {
    type: String,
    required: true
  },
  answer: {
    type: String,
    default: ''
  },
  defaultOpen: {
    type: Boolean,
    default: false
  }
})

const isOpen = ref(props.defaultOpen)

const toggleOpen = () => {
  isOpen.value = !isOpen.value
}
</script>
